"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports.withNotification = exports.NotificationProvider = exports.NotificationContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _verticalSpacer = _interopRequireDefault(require("../spacers/verticalSpacer"));

var _ = require("../..");

var _theme = _interopRequireDefault(require("../../styles/theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 1.4rem;\n  color: #3e3f42;\n  letter-spacing: 0.4px;\n  line-height: 2.2rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  @media (max-width: 767px) {\n    padding-right: 1.5rem;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0rem 0rem 0rem 1rem;\n  cursor: pointer;\n  @media (max-width: 767px) {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: fixed;\n  padding: 1.6rem 1rem 1rem 1.6rem;\n  right: 1rem;\n  z-index: 9999;\n  border-radius: 0.2rem;\n  background-color: #fff;\n  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.5);\n  /* left: 0; */\n  /* right: -75rem; */\n  /* margin: auto; */\n  top: 11rem;\n  right: 2rem;\n\n  @media (max-width: 767px) {\n    left: 1rem;\n    right: 1rem;\n    top: 7.6rem;\n    width: auto;\n    z-index: 999;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var NotificationContext = (0, _react.createContext)();
exports.NotificationContext = NotificationContext;

var Modal = _styledComponents["default"].div(_templateObject());

var CloseButton = _styledComponents["default"].div(_templateObject2());

var TopMessage = _styledComponents["default"].div(_templateObject3());

var Message = _styledComponents["default"].div(_templateObject4());

var NotificationProvider = function NotificationProvider(props, context) {
  var _useState = (0, _react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      error = _useState3[0],
      setError = _useState3[1];

  var timeout = (0, _react.useRef)(null);

  var handleOpenNotification = function handleOpenNotification(newMessage) {
    if (timeout) {
      clearTimeout(timeout.current);
    }

    setMessage(newMessage);
    setOpen(true);
    timeout.current = setTimeout(function () {
      setOpen(false);
    }, 3000);
  };

  var openNotification = function openNotification(message) {
    setError(false);
    handleOpenNotification(message);
  };

  var openErrorNotification = function openErrorNotification(message) {
    setError(true);
    handleOpenNotification(message);
  };

  var openComponentNotification = function openComponentNotification(Component, isError) {
    setError(isError);
    handleOpenNotification(Component);
  };

  return /*#__PURE__*/_react["default"].createElement(NotificationContext.Provider, {
    value: {
      openNotification: openNotification,
      openErrorNotification: openErrorNotification,
      openComponentNotification: openComponentNotification
    }
  }, open && /*#__PURE__*/_react["default"].createElement(Modal, null, /*#__PURE__*/_react["default"].createElement(TopMessage, null, !error && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.CheckAlt, {
    width: 20,
    height: 20,
    color: _theme["default"]["595b29c56bce953ca7b20909"].primary
  }), /*#__PURE__*/_react["default"].createElement(_verticalSpacer["default"], {
    width: "1rem"
  })), error && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.Error, {
    width: 20,
    height: 20,
    color: _theme["default"]["595b29c56bce953ca7b20909"].primary
  }), /*#__PURE__*/_react["default"].createElement(_verticalSpacer["default"], {
    width: "1rem"
  })), /*#__PURE__*/_react["default"].createElement(Message, null, /*#__PURE__*/_react["default"].createElement("div", null, message)), /*#__PURE__*/_react["default"].createElement(CloseButton, {
    onClick: function onClick() {
      clearTimeout(timeout);
      setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_.Close, {
    width: 25,
    height: 25,
    color: "#7C878E"
  })))), props.children);
};

exports.NotificationProvider = NotificationProvider;

var withNotification = function withNotification(Component) {
  return function WrapperComponent(props) {
    return /*#__PURE__*/_react["default"].createElement(NotificationContext.Consumer, null, function (state) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
        context: state
      }));
    });
  };
};

exports.withNotification = withNotification;